import { Link } from "react-router-dom";
import { contentNavData } from "constant/ContentNavBarData";

function NavbarPageNav() {
  const enabled = localStorage.getItem("ppv_enabled");

  // Show all when PPV is enabled, otherwise drop the last item
  const items =
    enabled === "1" ? contentNavData : contentNavData.slice(0, -1);

  return (
    <div className="submenu-main navbar rounded-2xl border border-white/10 bg-[#15151a]/95 p-3 text-center shadow-[0_20px_60px_rgba(0,0,0,0.5)] backdrop-blur-xl md:w-[300px] max-sm:top-[20px] max-sm:w-[320px]">
      <div className="grid grid-cols-3 gap-1 max-md:grid-cols-2 max-sm:grid-cols-3">
        {items.map((data: any, i: number) => (
          <Link
            to={data.link}
            key={i}
            className="group flex flex-col items-center gap-1.5 rounded-xl p-3 transition-colors hover:bg-white/5"
          >
            <span className="button-red flex h-11 w-11 items-center justify-center rounded-full transition-transform">
              <data.icon className="text-xl text-white" />
            </span>
            <p className="gray-text text-xs transition-colors group-hover:text-white">
              {data.title}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default NavbarPageNav;